import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../utils/combineStyles';
import classNames from 'classnames';
import ButtonStyles from '../../styles/button';
import SpacingStyles from '../../styles/helpers/spacing';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { INVOICE_STATUS } from './../../constants/constants';

const DISPUTE_STATUSES = [
  INVOICE_STATUS.IN_REVIEW,
  INVOICE_STATUS.AWAITING_REVISION
];
const ACCEPT_STATUSES = [
  INVOICE_STATUS.IN_REVIEW,
  INVOICE_STATUS.AWAITING_REVISION,
  INVOICE_STATUS.DISPUTED
];
const styles = () => ({
  moreOptionsButton: {
    position: 'absolute',
    right: 12
  },
  menuItemRoot: {
    color: 'rgba(12,31,44,0.87)',
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    backgroundColor: '#FFF !important',
    height: '40px',
    padding: '0 9px',
    '&:hover': {
      backgroundColor: 'whitesmoke !important'
    }
  },
  menuItemSelected: {
    backgroundColor: '#ebebeb !important'
  }
});

export class ButtonBar extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired
  };

  state = {
    anchorEl: null,
    moreMenuOpen: false
  };

  _handleMoreMenuClick = () => {
    this.setState({
      anchorEl: document.getElementById('moreButton'),
      moreMenuOpen: true
    });
  };
  _handleMoreMenuClose = () => {
    this.setState({ anchorEl: null, moreMenuOpen: false });
  };
  _handleEditClick = () => {
    this._handleMoreMenuClose();
    //TODO - need to implement this yet
  };
  _handleRejectClick = () => {
    this._handleMoreMenuClose();
    //TODO - need to implement this yet
  };
  _handleDisputeClick = () => {
    this._handleMoreMenuClose();
    //TODO - need to implement this yet
  };
  _handleDeleteClick = () => {
    this._handleMoreMenuClose();
    //TODO - need to implement this yet
  };

  render() {
    const { classes, t, invoice } = this.props;
    const { anchorEl, moreMenuOpen } = this.state;
    const showDispute = DISPUTE_STATUSES.includes(invoice.status);
    const showAccept = ACCEPT_STATUSES.includes(invoice.status);
    const showAwaitRevision = invoice.status === 'DISPUTED';
    const showAddDetails = invoice.status === 'PARSING_ERROR';

    return (
      <Fragment>
        <Fragment>
          {showAwaitRevision && (
            <Button
              variant="outlined"
              color="primary"
              onClick={this._handleRevision}
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
            >
              {t('Awaiting Revision')}
            </Button>
          )}
          {showDispute && (
            <Button
              variant="outlined"
              color="primary"
              onClick={this._handleDisputeClick}
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
            >
              {t('DISPUTE')}
            </Button>
          )}
          {showAccept && (
            <Button
              variant={invoice.shipmentId ? 'contained' : 'outlined'}
              color="primary"
              onClick={this._handleEdit}
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
            >
              {t('Accept')}
            </Button>
          )}

          {showAddDetails && (
            <Button
              variant="contained"
              color="primary"
              onClick={this._handleAddDetails}
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
            >
              {t('Add Invoice Details')}
            </Button>
          )}
        </Fragment>
        <IconButton
          id="moreButton"
          title={t('More Options')}
          aria-owns={anchorEl ? 'more-menu' : undefined}
          aria-haspopup="true"
          onClick={this._handleMoreMenuClick}
          classes={{
            root: classes.moreOptionsButton
          }}
          color={'primary'}
        >
          <MoreIcon className={classNames(classes.contentOption)} />
        </IconButton>
        <Menu
          id="more-menu"
          anchorEl={anchorEl}
          open={moreMenuOpen}
          onClose={this._handleMoreMenuClose}
        >
          <MenuItem
            onClick={this._handleEditClick}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected
            }}
          >
            {t('Edit Invoice')}
          </MenuItem>
          <MenuItem
            onClick={this._handleRejectClick}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected
            }}
          >
            {t('Reject')}
          </MenuItem>
          <MenuItem
            onClick={this._handleDeleteClick}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected
            }}
          >
            {t('Delete')}
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }
}

const buttonBarStyled = withStyles(
  combineStyles(styles, ButtonStyles, SpacingStyles)
)(ButtonBar);
const translatedButtonBar = withNamespaces()(buttonBarStyled);
export default translatedButtonBar;
